// extracted by mini-css-extract-plugin
module.exports =  {"StandaloneChat":"YlK7Au8Zm_d4CdMe7cBJ","StandaloneChat__Instance":"d9h_2I7ZxzZtTbu_TVkG"};